module.exports = __webpack_public_path__ + "img/ic_20_camera.e6ce4d16.svg";